module.exports = __webpack_public_path__ + "img/kotkip.19435406.svg";